import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { db, storage } from "@lib/firebase";
import {
  collection,
  addDoc,
  getDoc,
  doc,
  updateDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  limit,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useAuth } from "@context/AuthContext";
import { useNotification } from "../common/NotificationContext";
import { jsPDF } from "jspdf";
import { InputFieldRace, VoucherInput, Button } from "@cakrawalajakarta/shared-components";
import { serverTimestamp } from "firebase/firestore";

export const FormPendaftaran = ({ labelColor = "text-slate-800" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { title, price, foreignerPrice, eventId } = location.state || {};
  const { user } = useAuth();
  const { showNotification } = useNotification();

  const [formData, setFormData] = useState({
    namaDepan: "",
    namaBelakang: "",
    namaLengkap: "",
    email: "",
    telepon: "",
    nomorIdentitas: "",
    tanggalLahir: "",
    gender: "",
    negara: "Indonesia",
    provinsi: "",
    kota: "",
    alamat: "",
    kontakDarurat: "",
    namaKontakDarurat: "",
    hubunganKontakDarurat: "",
    bibName: "",
    golonganDarah: "",
    sizeJersey: "",
    performanceIndex: "",
    stravaProfile: "",
    teamName: "",
    participants: [
      {
        namaDepan: "",
        namaBelakang: "",
        bibName: "",
        telepon: "",
        nomorIdentitas: "",
        tanggalLahir: "",
        golonganDarah: "",
        sizeJersey: "",
        gender: "",
        negara: "Indonesia",
        provinsi: "",
        kota: "",
        alamat: "",
        kontakDarurat: "",
        namaKontakDarurat: "",
        hubunganKontakDarurat: "",
        performanceIndex: "",
        stravaProfile: "",
      },
      {
        namaDepan: "",
        namaBelakang: "",
        bibName: "",
        telepon: "",
        nomorIdentitas: "",
        tanggalLahir: "",
        golonganDarah: "",
        sizeJersey: "",
        gender: "",
        negara: "Indonesia",
        provinsi: "",
        kota: "",
        alamat: "",
        kontakDarurat: "",
        namaKontakDarurat: "",
        hubunganKontakDarurat: "",
        performanceIndex: "",
        stravaProfile: "",
      },
      {
        namaDepan: "",
        namaBelakang: "",
        bibName: "",
        telepon: "",
        nomorIdentitas: "",
        tanggalLahir: "",
        golonganDarah: "",
        sizeJersey: "",
        gender: "",
        negara: "Indonesia",
        provinsi: "",
        kota: "",
        alamat: "",
        kontakDarurat: "",
        namaKontakDarurat: "",
        hubunganKontakDarurat: "",
        performanceIndex: "",
        stravaProfile: "",
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSnapReady, setIsSnapReady] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [transactionStatus, setTransactionStatus] = useState(null);
  const [snapToken, setSnapToken] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [voucherCode, setVoucherCode] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(price || 0);
  const [collectionName, setCollectionName] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  const [distance, setDistance] = useState(null);
  const [isDraftLoaded, setIsDraftLoaded] = useState(false);

  const isGroupRegistration = eventId === "JOTR" && title.includes("Group");

  // Update finalPrice berdasarkan negara (peserta utama atau anggota tim)
  useEffect(() => {
    if (price && foreignerPrice) {
      let basePrice;
      if (isGroupRegistration) {
        const hasForeignParticipant =
          formData.negara !== "Indonesia" ||
          formData.participants.some(
            (participant) => participant.negara !== "Indonesia"
          );
        basePrice = hasForeignParticipant ? foreignerPrice : price;
      } else {
        basePrice = formData.negara === "Indonesia" ? price : foreignerPrice;
      }
      const newFinalPrice = Math.floor(basePrice * (1 - discount / 100));
      setFinalPrice(newFinalPrice);
    }
  }, [
    formData.negara,
    formData.participants,
    price,
    foreignerPrice,
    discount,
    isGroupRegistration,
  ]);

  const humanize = (str) => {
    if (!str) return "";
    if (str === "nomorIdentitas") return "Nomor Identitas";
    const withSpaces = str.replace(/([A-Z])/g, " $1").trim();
    return withSpaces
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const fetchCollectionName = async (eventId) => {
    try {
      const eventRef = doc(db, "semuaKegiatan", eventId);
      const eventDoc = await getDoc(eventRef);
      if (eventDoc.exists()) {
        const eventData = eventDoc.data();
        setCollectionName(eventData.collectionName || "pendaftaranJOTR");
        return eventData;
      }
      throw new Error("Dokumen event tidak ditemukan.");
    } catch (error) {
      setErrorMsg("Gagal mengambil data event. Silakan coba lagi.");
      showNotification(
        "error",
        "Gagal mengambil data event. Silakan coba lagi."
      );
      return null;
    }
  };

  const fetchCategoryDetails = async (eventId, title) => {
    try {
      const eventRef = doc(db, "semuaKegiatan", eventId);
      const eventDoc = await getDoc(eventRef);
      if (eventDoc.exists()) {
        const eventData = eventDoc.data();
        if (eventData.type === "seminar") {
          setCategoryName(eventData.title);
          setDistance(0);
        } else {
          const categories = eventData.categories || [];
          let selectedCategory = categories.find((cat) =>
            title.includes(cat.categoryName)
          );
          if (!selectedCategory && categories.length > 0) {
            selectedCategory = categories.find(
              (cat) => cat.categoryName === "Vertical 7K"
            );
          }
          if (selectedCategory) {
            setCategoryName(selectedCategory.categoryName);
            setDistance(selectedCategory.distance);
          } else {
            throw new Error("Kategori tidak ditemukan di data event.");
          }
        }
      } else {
        throw new Error("Dokumen event tidak ditemukan.");
      }
    } catch (error) {
      setErrorMsg("Gagal memuat detail kategori. Silakan coba lagi.");
      showNotification(
        "error",
        "Gagal memuat detail kategori. Silakan coba lagi."
      );
    }
  };

  const checkRegistration = async (collectionName) => {
    if (!user || !eventId || !collectionName) {
      return;
    }

    try {
      const q = query(
        collection(db, collectionName),
        where("uid", "==", user.uid),
        where("eventId", "==", eventId),
        where("kategori", "==", categoryName),
        limit(1)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        const data = doc.data();
        const status = data.transaction_status || "unknown";
        const paymentType = data.payment_type || "unknown";
        const harga = data.harga || 0;

        if (
          (status === "settlement" &&
            (paymentType === "free" || harga === 0)) ||
          (status === "pending" && paymentType !== "free") ||
          (status === "settlement" && paymentType !== "free" && data.snapToken)
        ) {
          setRegistrationStatus("registered");
          setTransactionStatus(status);
          setSnapToken(data.snapToken || null);
          setOrderId(data.orderId || null);
          setVoucherCode(data.voucherCode || null);
          setFormData((prev) => ({
            ...prev,
            teamName: isGroupRegistration ? data.teamName || prev.teamName : "",
          }));
        } else if (
          ["expire", "cancel", "deny"].includes(status) &&
          !data.snapToken
        ) {
          await deleteDoc(doc.ref);
          setRegistrationStatus("not_registered");
          setTransactionStatus(null);
          setSnapToken(null);
          setOrderId(null);
          setVoucherCode(null);
        }
      } else {
        setRegistrationStatus("not_registered");
      }
    } catch (err) {
      setErrorMsg("Gagal memeriksa status pendaftaran. Silakan coba lagi.");
      showNotification(
        "error",
        "Gagal memeriksa status pendaftaran. Silakan coba lagi."
      );
    }
  };

  const loadDraftData = async () => {
    if (!user || !eventId || !isGroupRegistration || isDraftLoaded) return;

    try {
      const draftDocRef = doc(db, "registrations", `${user.uid}_${eventId}`);
      const draftDoc = await getDoc(draftDocRef);
      if (draftDoc.exists()) {
        const draftData = draftDoc.data();
        if (draftData.status === "draft") {
          const updatedParticipants = draftData.participants.map(
            (participant, index) => ({
              namaDepan: participant.namaDepan || "",
              namaBelakang: participant.namaBelakang || "",
              bibName: participant.bibName || "",
              telepon: participant.telepon || "",
              nomorIdentitas: participant.nomorIdentitas || "",
              tanggalLahir: participant.tanggalLahir || "",
              golonganDarah: participant.golonganDarah || "",
              sizeJersey: participant.sizeJersey || "",
              gender: participant.gender || "",
              negara: participant.negara || "Indonesia",
              provinsi: participant.provinsi || "",
              kota: participant.kota || "",
              alamat: participant.alamat || "",
              kontakDarurat: participant.kontakDarurat || "",
              namaKontakDarurat: participant.namaKontakDarurat || "",
              hubunganKontakDarurat: participant.hubunganKontakDarurat || "",
              performanceIndex: participant.performanceIndex || "",
              stravaProfile: participant.stravaProfile || "",
            })
          );
          setFormData((prev) => {
            const firstParticipant = updatedParticipants[0] || {};
            const newFormData = {
              ...prev,
              teamName: draftData.teamName || "",
              participants: updatedParticipants,
              namaDepan: firstParticipant.namaDepan || prev.namaDepan,
              namaBelakang: firstParticipant.namaBelakang || prev.namaBelakang,
              namaLengkap:
                firstParticipant.namaDepan && firstParticipant.namaBelakang
                  ? `${firstParticipant.namaDepan} ${firstParticipant.namaBelakang}`.trim()
                  : prev.namaLengkap,
              telepon: firstParticipant.telepon || prev.telepon,
              nomorIdentitas:
                firstParticipant.nomorIdentitas || prev.nomorIdentitas,
              tanggalLahir: firstParticipant.tanggalLahir || prev.tanggalLahir,
              gender: firstParticipant.gender || prev.gender,
              negara: firstParticipant.negara || prev.negara,
              provinsi: firstParticipant.provinsi || prev.provinsi,
              kota: firstParticipant.kota || prev.kota,
              alamat: firstParticipant.alamat || prev.alamat,
              kontakDarurat:
                firstParticipant.kontakDarurat || prev.kontakDarurat,
              namaKontakDarurat:
                firstParticipant.namaKontakDarurat || prev.namaKontakDarurat,
              hubunganKontakDarurat:
                firstParticipant.hubunganKontakDarurat ||
                prev.hubunganKontakDarurat,
              bibName: firstParticipant.bibName || prev.bibName,
              golonganDarah:
                firstParticipant.golonganDarah || prev.golonganDarah,
              sizeJersey: firstParticipant.sizeJersey || prev.sizeJersey,
              performanceIndex:
                firstParticipant.performanceIndex || prev.performanceIndex,
              stravaProfile:
                firstParticipant.stravaProfile || prev.stravaProfile,
            };
            return newFormData;
          });
          showNotification(
            "success",
            "Data draft sebelumnya telah dimuat. Silakan lanjutkan pengisian atau submit."
          );
          setIsDraftLoaded(true);
        }
      } else {
        setIsDraftLoaded(true);
      }
    } catch (err) {
      setErrorMsg("Gagal memuat data draft. Silakan coba lagi.");
      showNotification("error", "Gagal memuat data draft. Silakan coba lagi.");
      setIsDraftLoaded(true);
    }
  };

  useEffect(() => {
    if (!eventId || !title || !price || !foreignerPrice) {
      showNotification(
        "error",
        "Silakan pilih kategori dari halaman kegiatan."
      );
      navigate("/");
      return;
    }

    if (!Number.isInteger(price) || !Number.isInteger(foreignerPrice)) {
      setErrorMsg("Harga event tidak valid.");
      showNotification("error", "Harga event tidak valid.");
      navigate("/");
      return;
    }

    const initialize = async () => {
      if (!user) {
        navigate("/login");
        showNotification("error", "Silakan login untuk mendaftar.");
        return;
      }

      try {
        const eventData = await fetchCollectionName(eventId);
        if (!eventData) {
          navigate("/");
          return;
        }
        await fetchCategoryDetails(eventId, title);

        if (isGroupRegistration && !isDraftLoaded) {
          await loadDraftData();
        }

        if (!isDraftLoaded || !isGroupRegistration) {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          let userData = {};

          if (docSnap.exists()) {
            userData = docSnap.data();
            let namaDepan = userData.namaDepan || "";
            let namaBelakang = userData.namaBelakang || "";
            let namaLengkap = userData.namaLengkap || "";

            if (!namaDepan && !namaBelakang && namaLengkap) {
              const namaSplit = namaLengkap.trim().split(/\s+/);
              namaDepan = namaSplit[0] || "";
              namaBelakang = namaSplit.slice(1).join(" ") || "";
            }

            let participants = formData.participants;
            let rootFields = {};
            if (isGroupRegistration) {
              participants = [
                {
                  namaDepan,
                  namaBelakang,
                  bibName: userData.bibName || "",
                  telepon: userData.telepon || "",
                  nomorIdentitas: userData.nomorIdentitas || "",
                  tanggalLahir: userData.tanggalLahir || "",
                  golonganDarah: userData.golonganDarah || "",
                  sizeJersey: userData.sizeJersey || "",
                  gender: userData.gender || "",
                  negara: userData.negara || "Indonesia",
                  provinsi: userData.provinsi || "",
                  kota: userData.kota || "",
                  alamat: userData.alamat || "",
                  kontakDarurat: userData.kontakDarurat || "",
                  namaKontakDarurat: userData.namaKontakDarurat || "",
                  hubunganKontakDarurat: userData.hubunganKontakDarurat || "",
                  performanceIndex: userData.performanceIndex || "",
                  stravaProfile: userData.stravaProfile || "",
                },
                {
                  namaDepan: "",
                  namaBelakang: "",
                  bibName: "",
                  telepon: "",
                  nomorIdentitas: "",
                  tanggalLahir: "",
                  golonganDarah: "",
                  sizeJersey: "",
                  gender: "",
                  negara: "Indonesia",
                  provinsi: "",
                  kota: "",
                  alamat: "",
                  kontakDarurat: "",
                  namaKontakDarurat: "",
                  hubunganKontakDarurat: "",
                  performanceIndex: "",
                  stravaProfile: "",
                },
                {
                  namaDepan: "",
                  namaBelakang: "",
                  bibName: "",
                  telepon: "",
                  nomorIdentitas: "",
                  tanggalLahir: "",
                  golonganDarah: "",
                  sizeJersey: "",
                  gender: "",
                  negara: "Indonesia",
                  provinsi: "",
                  kota: "",
                  alamat: "",
                  kontakDarurat: "",
                  namaKontakDarurat: "",
                  hubunganKontakDarurat: "",
                  performanceIndex: "",
                  stravaProfile: "",
                },
              ];
              rootFields = {
                namaDepan,
                namaBelakang,
                namaLengkap:
                  namaLengkap || `${namaDepan} ${namaBelakang}`.trim(),
                email: userData.email || user.email || "",
                telepon: userData.telepon || "",
                nomorIdentitas: userData.nomorIdentitas || "",
                tanggalLahir: userData.tanggalLahir || "",
                gender: userData.gender || "",
                negara: userData.negara || "Indonesia",
                provinsi: userData.provinsi || "",
                kota: userData.kota || "",
                alamat: userData.alamat || "",
                kontakDarurat: userData.kontakDarurat || "",
                namaKontakDarurat: userData.namaKontakDarurat || "",
                hubunganKontakDarurat: userData.hubunganKontakDarurat || "",
                bibName: eventId === "JOTR" ? userData.bibName || "" : "",
                golonganDarah:
                  eventId === "JOTR" ? userData.golonganDarah || "" : "",
                sizeJersey: eventId === "JOTR" ? userData.sizeJersey || "" : "",
                performanceIndex:
                  eventId === "JOTR" ? userData.performanceIndex || "" : "",
                stravaProfile:
                  eventId === "JOTR" ? userData.stravaProfile || "" : "",
              };
            } else {
              rootFields = {
                namaDepan,
                namaBelakang,
                namaLengkap:
                  namaLengkap || `${namaDepan} ${namaBelakang}`.trim(),
                email: userData.email || user.email || "",
                telepon: userData.telepon || "",
                nomorIdentitas: userData.nomorIdentitas || "",
                tanggalLahir: userData.tanggalLahir || "",
                gender: userData.gender || "",
                negara: userData.negara || "Indonesia",
                provinsi: userData.provinsi || "",
                kota: userData.kota || "",
                alamat: userData.alamat || "",
                kontakDarurat: userData.kontakDarurat || "",
                namaKontakDarurat: userData.namaKontakDarurat || "",
                hubunganKontakDarurat: userData.hubunganKontakDarurat || "",
                bibName:
                  eventId === "JOTR" && !isGroupRegistration
                    ? userData.bibName || ""
                    : "",
                golonganDarah:
                  eventId === "JOTR" && !isGroupRegistration
                    ? userData.golonganDarah || ""
                    : "",
                sizeJersey:
                  eventId === "JOTR" && !isGroupRegistration
                    ? userData.sizeJersey || ""
                    : "",
                performanceIndex:
                  eventId === "JOTR" && !isGroupRegistration
                    ? userData.performanceIndex || ""
                    : "",
                stravaProfile:
                  eventId === "JOTR" && !isGroupRegistration
                    ? userData.stravaProfile || ""
                    : "",
              };
            }

            setFormData((prev) => {
              const newFormData = {
                ...prev,
                ...rootFields,
                teamName: isGroupRegistration ? prev.teamName : "",
                participants: isGroupRegistration
                  ? participants
                  : prev.participants,
              };
              return newFormData;
            });
          } else {
            const namaSplit = (user.displayName || "").trim().split(/\s+/);
            const namaDepan = namaSplit[0] || "";
            const namaBelakang = namaSplit.slice(1).join(" ") || "";
            setFormData((prev) => {
              const newFormData = {
                ...prev,
                namaDepan,
                namaBelakang,
                namaLengkap:
                  namaDepan && namaBelakang
                    ? `${namaDepan} ${namaBelakang}`.trim()
                    : "",
                email: user.email || "",
              };
              return newFormData;
            });
          }
        }

        if (collectionName && categoryName) {
          await checkRegistration(collectionName);
        }
      } catch (err) {
        setErrorMsg("Gagal mengambil data pengguna.");
        showNotification("error", "Gagal mengambil data pengguna.");
        return;
      }
    };

    const checkSnap = setInterval(() => {
      if (window.snap) {
        setIsSnapReady(true);
        clearInterval(checkSnap);
      }
    }, 100);

    if (eventId && title && price && user) {
      initialize();
    } else {
      showNotification(
        "error",
        "Silakan pilih kategori dari halaman kegiatan."
      );
      navigate("/");
    }

    return () => clearInterval(checkSnap);
  }, [
    eventId,
    title,
    price,
    foreignerPrice,
    navigate,
    showNotification,
    user,
    collectionName,
    categoryName,
  ]);

  const handleChange = (e, participantIndex = null) => {
    if (participantIndex !== null) {
      const { name, value } = e.target;
      setFormData((prev) => {
        const updatedParticipants = [...prev.participants];
        updatedParticipants[participantIndex] = {
          ...updatedParticipants[participantIndex],
          [name]: value,
        };
        const updatedFormData = { ...prev, participants: updatedParticipants };
        if (participantIndex === 0 && name === "negara") {
          updatedFormData.negara = value;
        }
        return updatedFormData;
      });
    } else {
      const { name, value } = e.target;
      setFormData((prev) => {
        const updated = { ...prev, [name]: value };
        if (name === "namaDepan" || name === "namaBelakang") {
          updated.namaLengkap = `${updated.namaDepan || ""} ${
            updated.namaBelakang || ""
          }`.trim();
        }
        if (name === "namaLengkap") {
          const namaSplit = value.trim().split(/\s+/);
          updated.namaDepan = namaSplit[0] || "";
          updated.namaBelakang = namaSplit.slice(1).join(" ") || "";
        }
        if (isGroupRegistration && name === "negara") {
          const updatedParticipants = [...updated.participants];
          updatedParticipants[0] = {
            ...updatedParticipants[0],
            negara: value,
          };
          updated.participants = updatedParticipants;
        }
        return updated;
      });
    }
  };

  const handleApplyVoucher = (code, discountPercentage) => {
    setVoucherCode(code);
    setDiscount(discountPercentage);
    let basePrice;
    if (isGroupRegistration) {
      const hasForeignParticipant =
        formData.negara !== "Indonesia" ||
        formData.participants.some(
          (participant) => participant.negara !== "Indonesia"
        );
      basePrice = hasForeignParticipant ? foreignerPrice : price;
    } else {
      basePrice = formData.negara === "Indonesia" ? price : foreignerPrice;
    }
    const newFinalPrice = Math.floor(
      basePrice * (1 - discountPercentage / 100)
    );
    setFinalPrice(newFinalPrice);
  };

  const updateUserData = async (updatedFields) => {
    try {
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);
      const existingData = docSnap.exists() ? docSnap.data() : {};

      const fieldsToUpdate = {};
      Object.keys(updatedFields).forEach((key) => {
        if (
          key !== "participants" &&
          key !== "teamName" &&
          updatedFields[key] !== undefined &&
          updatedFields[key] !== ""
        ) {
          fieldsToUpdate[key] = updatedFields[key];
        } else if (!existingData[key]) {
          fieldsToUpdate[key] = "";
        }
      });
      fieldsToUpdate.updatedAt = serverTimestamp();

      await updateDoc(docRef, fieldsToUpdate);
    } catch (err) {
      setErrorMsg("Gagal memperbarui data pengguna.");
      showNotification("error", "Gagal memperbarui data pengguna.");
    }
  };

  const simpanSuratPernyataanSebagaiPDF = async () => {
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const marginLeft = 20;
    const marginTop = 20;
    const lineHeight = 7;
    const bulletIndent = 5;
    let yPosition = marginTop;

    // Header
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("SURAT PERNYATAAN", 105, yPosition, { align: "center" });
    yPosition += lineHeight * 2;

    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");

    // Informasi peserta
    const namaLengkap = formData.namaLengkap || "Unknown";
    const today = new Date();
    const tanggal = today.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    pdf.text(`Nama: ${namaLengkap}`, marginLeft, yPosition);
    yPosition += lineHeight;
    if (isGroupRegistration) {
      pdf.text(
        `Nama Tim: ${formData.teamName || "Unknown"}`,
        marginLeft,
        yPosition
      );
      yPosition += lineHeight;
    }
    pdf.text(`Tanggal: ${tanggal}`, marginLeft, yPosition);
    yPosition += lineHeight * 2;

    // Isi surat
    const paragraphs = [
      `Dengan ini menyatakan bahwa saya secara sukarela dan sadar mendaftarkan diri${
        isGroupRegistration ? " dan tim saya" : ""
      } sebagai peserta dalam kegiatan Jakarta Open TrailRun (JOTR) 2025 - KEJURDA I yang diselenggarakan oleh ALTI DKI Jakarta, yang akan dilaksanakan pada tanggal 27-28 September 2025 di kawasan Taman Nasional Gunung Gede Pangrango.`,
      "Saya memahami bahwa kegiatan ini bersifat trail run yang menantang secara fisik dan mental, serta memiliki potensi risiko, seperti kondisi cuaca ekstrem, kontur medan yang berat, dan gangguan kesehatan lainnya. Oleh karena itu, saya menyatakan bahwa saya telah mempersiapkan diri secara optimal untuk mengikuti lomba ini dan dalam kondisi kesehatan yang baik.",
      `Saya juga menyadari bahwa panitia penyelenggara, relawan, sponsor, maupun pihak-pihak terkait lainnya tidak bertanggung jawab secara hukum atas risiko cedera, kecelakaan, kehilangan, atau kejadian darurat lainnya yang mungkin ${
        isGroupRegistration ? "saya atau anggota tim saya" : "saya"
      } alami selama mengikuti rangkaian kegiatan. Seluruh tanggung jawab atas keselamatan dan kesehatan pribadi selama kegiatan merupakan tanggung jawab ${
        isGroupRegistration ? "saya dan anggota tim saya" : "saya sendiri"
      }, dan saya melepaskan panitia dari segala bentuk tuntutan hukum atas kejadian yang mungkin timbul selama atau akibat keikutsertaan ${
        isGroupRegistration ? "saya dan tim saya" : "saya"
      } dalam kegiatan ini.`,
      "Saya berkomitmen untuk:",
      [
        "Mengikuti seluruh peraturan dan arahan dari panitia dan pihak berwenang.",
        "Menjaga sportivitas, keamanan, dan ketertiban selama kegiatan berlangsung.",
        "Tidak melakukan tindakan yang merugikan diri sendiri, peserta lain, panitia, maupun lingkungan sekitar.",
      ],
      `Saya juga memberikan izin penuh kepada panitia untuk menggunakan dokumentasi (foto, video, atau lainnya) yang memuat identitas atau citra ${
        isGroupRegistration ? "saya dan anggota tim saya" : "saya"
      } untuk keperluan publikasi, promosi, dan dokumentasi kegiatan tanpa memerlukan izin tambahan.`,
      `Dengan ini, saya menyatakan telah membaca, memahami, dan menyetujui seluruh isi pernyataan ini dengan sadar, sukarela, dan tanpa tekanan dari pihak mana pun. Pernyataan ini saya buat sebagai bentuk komitmen dan tanggung jawab ${
        isGroupRegistration ? "saya dan tim saya" : "saya"
      } sebagai peserta dalam JOTR 2025.`,
    ];

    paragraphs.forEach((item) => {
      if (Array.isArray(item)) {
        item.forEach((bullet) => {
          const lines = pdf.splitTextToSize(bullet, 170 - bulletIndent);
          lines.forEach((line, index) => {
            if (yPosition + lineHeight > 277) {
              pdf.addPage();
              yPosition = marginTop;
            }
            const text = index === 0 ? `• ${line}` : line;
            const xOffset =
              index === 0 ? marginLeft : marginLeft + bulletIndent;
            pdf.text(text, xOffset, yPosition);
            yPosition += lineHeight;
          });
        });
      } else {
        const lines = pdf.splitTextToSize(item, 170);
        lines.forEach((line) => {
          if (yPosition + lineHeight > 277) {
            pdf.addPage();
            yPosition = marginTop;
          }
          pdf.text(line, marginLeft, yPosition);
          yPosition += lineHeight;
        });
      }
      yPosition += lineHeight;
    });

    if (yPosition + lineHeight * 3 > 277) {
      pdf.addPage();
      yPosition = marginTop;
    }
    pdf.text("Hormat saya,", 170, yPosition, { align: "right" });
    yPosition += lineHeight * 2;
    pdf.setFont("helvetica", "bold");
    pdf.text(namaLengkap, 170, yPosition, { align: "right" });

    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      pdf.text(`Halaman ${i} dari ${pageCount}`, 105, 287, { align: "center" });
    }

    const pdfBlob = pdf.output("blob");
    const fileName = `Surat_Pernyataan_${namaLengkap.replace(
      /\s+/g,
      "_"
    )}_${eventId}${
      isGroupRegistration ? `_${formData.teamName.replace(/\s+/g, "_")}` : ""
    }.pdf`;

    try {
      console.log(`🔄 Mengunggah surat pernyataan untuk user ${user.uid}...`);
      const suratQuery = query(
        collection(db, "suratPernyataan"),
        where("userId", "==", user.uid),
        where("eventId", "==", eventId),
        limit(1)
      );
      const suratSnapshot = await getDocs(suratQuery);
      if (!suratSnapshot.empty) {
        console.log(
          `⚠️ Surat pernyataan untuk user ${user.uid} sudah ada, melewati...`
        );
        return;
      }

      const storageRef = ref(
        storage,
        `suratPernyataan/${user.uid}/${fileName}`
      );
      await uploadBytes(storageRef, pdfBlob);
      const downloadURL = await getDownloadURL(storageRef);
      console.log(
        `✅ File ${fileName} berhasil diunggah untuk user ${user.uid}`
      );

      const docData = {
        namaLengkap,
        tanggal,
        fileName,
        downloadURL,
        createdAt: serverTimestamp(),
        userId: user.uid,
        eventId,
      };
      if (isGroupRegistration) {
        docData.teamName = formData.teamName || "Unknown";
      }

      await addDoc(collection(db, "suratPernyataan"), docData);
      console.log(
        `✅ Metadata surat pernyataan disimpan untuk user ${user.uid}`
      );
    } catch (err) {
      console.error(
        `❌ Gagal menyimpan surat pernyataan untuk user ${user.uid}:`,
        err.message
      );
      setErrorMsg("Gagal menyimpan surat pernyataan.");
      showNotification("error", "Gagal menyimpan surat pernyataan.");
      throw err;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    if (!isSnapReady) {
      setErrorMsg("Midtrans sedang disiapkan, mohon tunggu sebentar.");
      showNotification(
        "error",
        "Midtrans sedang disiapkan, mohon tunggu sebentar."
      );
      setLoading(false);
      return;
    }

    if (!isChecked) {
      setErrorMsg("Harap setujui Surat Pernyataan sebelum melanjutkan.");
      showNotification(
        "error",
        "Harap setujui Surat Pernyataan sebelum melanjutkan."
      );
      setLoading(false);
      return;
    }

    if (!categoryName || (eventId !== "PelatihanPelatih" && !distance)) {
      setErrorMsg("Data kategori atau jarak tidak lengkap.");
      showNotification("error", "Data kategori atau jarak tidak lengkap.");
      setLoading(false);
      return;
    }

    const validateFormat = (
      field,
      value,
      participantIndex = null,
      negara = "Indonesia"
    ) => {
      const prefix =
        participantIndex !== null ? `Peserta ${participantIndex + 1}: ` : "";
      const label = humanize(field);

      if (!value || value.trim() === "") {
        return `${prefix}${label} wajib diisi`;
      }
      if (field === "teamName" && !/^[A-Za-z0-9\s]{3,50}$/.test(value)) {
        return `${prefix}${label} harus 3-50 karakter, alfanumerik dengan spasi.`;
      }
      if (
        (field === "namaDepan" || field === "namaBelakang") &&
        !/^[A-Za-z\s]{1,50}$/.test(value)
      ) {
        return `${prefix}${label} hanya boleh huruf dan spasi, maksimum 50 karakter.`;
      }
      if (field === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return `${prefix}${label} harus dalam format yang valid (contoh: user@example.com).`;
      }
      if (field === "bibName" && !/^[A-Za-z0-9\s]{1,20}$/.test(value)) {
        return `${prefix}${label} harus 1-20 karakter alfanumerik dan spasi.`;
      }
      if (
        (field === "telepon" || field === "kontakDarurat") &&
        !/^\+?\d{8,15}$/.test(value)
      ) {
        return `${prefix}${label} harus 8-15 digit, boleh diawali dengan "+".`;
      }
      if (field === "nomorIdentitas") {
        if (negara === "Indonesia") {
          if (!/^\d{16}$/.test(value)) {
            return `${prefix}${label} (KTP) harus 16 digit untuk peserta dari Indonesia.`;
          }
        } else {
          if (!/^[A-Za-z0-9]{5,20}$/.test(value)) {
            return `${prefix}${label} (Paspor/Identitas) harus 5-20 karakter alfanumerik untuk peserta asing.`;
          }
        }
      }
      if (field === "tanggalLahir") {
        const date = new Date(value);
        const eventDate = new Date("2025-09-27");
        const minAgeDate = new Date(
          eventDate.getFullYear() - 15,
          eventDate.getMonth(),
          eventDate.getDate()
        );
        if (isNaN(date.getTime()) || date >= eventDate) {
          return `${prefix}${label} harus di masa lalu sebelum 27/9/2025, misalnya: "2010-09-27"`;
        } else if (date > minAgeDate) {
          return `${prefix}Peserta harus berusia minimal 15 tahun pada 27/9/2025, misalnya: "2010-09-27" atau sebelumnya`;
        }
      }
      if (field === "golonganDarah" && !["A", "B", "AB", "O"].includes(value)) {
        return `${prefix}${label} harus A, B, AB, atau O.`;
      }
      if (
        field === "sizeJersey" &&
        !["S", "M", "L", "XL", "XXL"].includes(value)
      ) {
        return `${prefix}${label} harus S, M, L, XL, atau XXL.`;
      }
      if (field === "gender" && !["Laki-laki", "Perempuan"].includes(value)) {
        return `${prefix}${label} harus Laki-laki atau Perempuan.`;
      }
      if (field === "alamat" && (value.trim().length < 5 || value.trim().length > 200)) {
        return `${prefix}${label} harus antara 5 hingga 200 karakter.`;
      }
      if (field === "namaKontakDarurat" && !/^[A-Za-z\s]{1,50}$/.test(value)) {
        return `${prefix}${label} hanya boleh huruf dan spasi, maksimum 50 karakter.`;
      }
      if (
        field === "hubunganKontakDarurat" &&
        !/^[A-Za-z\s]{1,50}$/.test(value)
      ) {
        return `${prefix}${label} hanya boleh huruf dan spasi, maksimum 50 karakter.`;
      }
      if (field === "performanceIndex" && !/^\d{3}$/.test(value)) {
        return `${prefix}${label} harus berupa 3 digit angka, isi "000" jika tidak ada index`;
      }
      if (field === "stravaProfile" && !value.trim()) {
        return `${prefix} atau applikasi sejenis wajib diisi`;
      }
      return "";
    };

    const requiredFields = [
      "namaDepan",
      "namaBelakang",
      "email",
      "telepon",
      "nomorIdentitas",
      "tanggalLahir",
      "gender",
      "negara",
      "provinsi",
      "kota",
      "alamat",
      "kontakDarurat",
      "namaKontakDarurat",
      "hubunganKontakDarurat",
      ...(eventId === "JOTR"
        ? [
            "bibName",
            "golonganDarah",
            "sizeJersey",
            "performanceIndex",
            "stravaProfile",
          ]
        : []),
    ];

    const errors = {};
    for (const field of requiredFields) {
      const error = validateFormat(
        field,
        formData[field],
        null,
        formData.negara
      );
      if (error) {
        errors[field] = error;
      }
    }

    if (isGroupRegistration) {
      const teamNameError = validateFormat("teamName", formData.teamName);
      if (teamNameError) {
        errors.teamName = teamNameError;
      }
      if (formData.participants.length !== 3) {
        errors.participants = "Tim harus terdiri dari tepat 3 peserta.";
      } else {
        const allMale = formData.participants.every(
          (p) => p.gender === "Laki-laki"
        );
        if (allMale) {
          errors.gender =
            "Tim tidak boleh terdiri dari pria semua. Minimal satu peserta harus perempuan.";
        }
        const requiredFieldsParticipants = [
          "namaDepan",
          "namaBelakang",
          "telepon",
          "nomorIdentitas",
          "tanggalLahir",
          "golonganDarah",
          "sizeJersey",
          "gender",
          "negara",
          "provinsi",
          "kota",
          "alamat",
          "kontakDarurat",
          "namaKontakDarurat",
          "hubunganKontakDarurat",
          "performanceIndex",
          "stravaProfile",
        ];
        const bibNames = new Set();
        for (let i = 0; i < formData.participants.length; i++) {
          const participant = formData.participants[i];
          for (const field of requiredFieldsParticipants) {
            const error = validateFormat(
              field,
              participant[field],
              i,
              participant.negara
            );
            if (error) {
              errors[`${field}_${i}`] = error;
            }
          }
          if (participant.bibName) {
            if (bibNames.has(participant.bibName)) {
              errors[`bibName_${i}`] = `BIB Name untuk peserta ${
                i + 1
              } sudah digunakan.`;
            } else {
              bibNames.add(participant.bibName);
            }
          }
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      setErrorMsg(firstError);
      showNotification("error", firstError);
      setFormData((prev) => ({ ...prev, errors }));
      setLoading(false);
      return;
    }

    if (!Number.isInteger(finalPrice)) {
      setErrorMsg("Harga akhir harus berupa bilangan bulat.");
      showNotification("error", "Harga akhir harus berupa bilangan bulat.");
      setLoading(false);
      return;
    }

    try {
      if (!eventId || !title || !price || !foreignerPrice) {
        throw new Error(
          "Data event tidak lengkap. Silakan coba lagi dari halaman kategori."
        );
      }

      const sanitizeValue = (value) => {
        if (typeof value === "string") {
          const trimmed = value.trim();
          return trimmed === "" ? undefined : trimmed.replace(/\s+/g, " ");
        }
        return value;
      };

      const sanitizedFormData = {
        ...formData,
        namaDepan: sanitizeValue(formData.namaDepan),
        namaBelakang: sanitizeValue(formData.namaBelakang),
        namaLengkap: sanitizeValue(formData.namaLengkap),
        email: sanitizeValue(formData.email),
        telepon: sanitizeValue(formData.telepon),
        nomorIdentitas: formData.nomorIdentitas
          ? formData.nomorIdentitas.trim().replace(/\s+/g, "")
          : undefined,
        tanggalLahir: sanitizeValue(formData.tanggalLahir),
        gender: sanitizeValue(formData.gender),
        negara: sanitizeValue(formData.negara),
        provinsi: sanitizeValue(formData.provinsi),
        kota: sanitizeValue(formData.kota),
        alamat: sanitizeValue(formData.alamat),
        kontakDarurat: sanitizeValue(formData.kontakDarurat),
        namaKontakDarurat: sanitizeValue(formData.namaKontakDarurat),
        hubunganKontakDarurat: sanitizeValue(formData.hubunganKontakDarurat),
        bibName:
          eventId === "JOTR" ? sanitizeValue(formData.bibName) : undefined,
        golonganDarah:
          eventId === "JOTR"
            ? sanitizeValue(formData.golonganDarah)
            : undefined,
        sizeJersey:
          eventId === "JOTR" ? sanitizeValue(formData.sizeJersey) : undefined,
        performanceIndex:
          eventId === "JOTR"
            ? sanitizeValue(formData.performanceIndex)
            : undefined,
        stravaProfile:
          eventId === "JOTR"
            ? sanitizeValue(formData.stravaProfile)
            : undefined,
        teamName: isGroupRegistration
          ? sanitizeValue(formData.teamName)
          : undefined,
        participants: isGroupRegistration
          ? formData.participants.map((participant) => ({
              namaDepan: sanitizeValue(participant.namaDepan),
              namaBelakang: sanitizeValue(participant.namaBelakang),
              telepon: sanitizeValue(participant.telepon),
              nomorIdentitas: participant.nomorIdentitas
                ? participant.nomorIdentitas.trim().replace(/\s+/g, "")
                : undefined,
              tanggalLahir: sanitizeValue(participant.tanggalLahir),
              golonganDarah: sanitizeValue(participant.golonganDarah),
              sizeJersey: sanitizeValue(participant.sizeJersey),
              gender: sanitizeValue(participant.gender),
              negara: sanitizeValue(participant.negara),
              provinsi: sanitizeValue(participant.provinsi),
              kota: sanitizeValue(participant.kota),
              alamat: sanitizeValue(participant.alamat),
              kontakDarurat: sanitizeValue(participant.kontakDarurat),
              namaKontakDarurat: sanitizeValue(participant.namaKontakDarurat),
              hubunganKontakDarurat: sanitizeValue(
                participant.hubunganKontakDarurat
              ),
              performanceIndex: sanitizeValue(participant.performanceIndex),
              stravaProfile: sanitizeValue(participant.stravaProfile),
              bibName: sanitizeValue(participant.bibName),
            }))
          : formData.participants,
      };

      const sanitizedErrors = {};
      for (const field of requiredFields) {
        const error = validateFormat(
          field,
          sanitizedFormData[field],
          null,
          sanitizedFormData.negara
        );
        if (error) {
          sanitizedErrors[field] = error;
        }
      }
      if (isGroupRegistration) {
        const teamNameError = validateFormat(
          "teamName",
          sanitizedFormData.teamName
        );
        if (teamNameError) {
          sanitizedErrors.teamName = teamNameError;
        }
        if (sanitizedFormData.participants.length !== 3) {
          sanitizedErrors.participants =
            "Tim harus terdiri dari tepat 3 peserta.";
        } else {
          const allMale = sanitizedFormData.participants.every(
            (p) => p.gender === "Laki-laki"
          );
          if (allMale) {
            sanitizedErrors.gender =
              "Tim tidak boleh terdiri dari pria semua. Minimal satu peserta harus perempuan.";
          }
          const requiredFieldsParticipants = [
            "namaDepan",
            "namaBelakang",
            "telepon",
            "nomorIdentitas",
            "tanggalLahir",
            "golonganDarah",
            "sizeJersey",
            "gender",
            "negara",
            "provinsi",
            "kota",
            "alamat",
            "kontakDarurat",
            "namaKontakDarurat",
            "hubunganKontakDarurat",
            "performanceIndex",
            "stravaProfile",
          ];
          const bibNames = new Set();
          for (let i = 0; i < sanitizedFormData.participants.length; i++) {
            const participant = sanitizedFormData.participants[i];
            for (const field of requiredFieldsParticipants) {
              const error = validateFormat(
                field,
                participant[field],
                i,
                participant.negara
              );
              if (error) {
                sanitizedErrors[`${field}_${i}`] = error;
              }
            }
            if (participant.bibName) {
              if (bibNames.has(participant.bibName)) {
                sanitizedErrors[`bibName_${i}`] = `BIB Name untuk peserta ${
                  i + 1
                } sudah digunakan.`;
              } else {
                bibNames.add(participant.bibName);
              }
            }
          }
        }
      }

      if (Object.keys(sanitizedErrors).length > 0) {
        const firstError = Object.values(sanitizedErrors)[0];
        setErrorMsg(firstError);
        showNotification("error", firstError);
        setFormData((prev) => ({ ...prev, errors: sanitizedErrors }));
        setLoading(false);
        return;
      }

      const updatedUserData = {
        namaDepan: sanitizedFormData.namaDepan,
        namaBelakang: sanitizedFormData.namaBelakang,
        namaLengkap: sanitizedFormData.namaLengkap,
        telepon: sanitizedFormData.telepon,
        nomorIdentitas: sanitizedFormData.nomorIdentitas,
        tanggalLahir: sanitizedFormData.tanggalLahir,
        gender: sanitizedFormData.gender,
        negara: sanitizedFormData.negara,
        provinsi: sanitizedFormData.provinsi,
        kota: sanitizedFormData.kota,
        alamat: sanitizedFormData.alamat,
        kontakDarurat: sanitizedFormData.kontakDarurat,
        namaKontakDarurat: sanitizedFormData.namaKontakDarurat,
        hubunganKontakDarurat: sanitizedFormData.hubunganKontakDarurat,
        bibName: eventId === "JOTR" ? sanitizedFormData.bibName : undefined,
        golonganDarah:
          eventId === "JOTR" ? sanitizedFormData.golonganDarah : undefined,
        sizeJersey:
          eventId === "JOTR" ? sanitizedFormData.sizeJersey : undefined,
        performanceIndex:
          eventId === "JOTR" ? sanitizedFormData.performanceIndex : undefined,
        stravaProfile:
          eventId === "JOTR" ? sanitizedFormData.stravaProfile : undefined,
      };

      await updateUserData(updatedUserData);

      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        throw new Error(
          "Data pengguna tidak ditemukan di Firestore setelah pembaruan."
        );
      }
      const userData = userDoc.data();

      const requiredUserFields = [
        "namaDepan",
        "namaBelakang",
        "bibName",
        "nomorIdentitas",
        "tanggalLahir",
        "golonganDarah",
        "sizeJersey",
        "gender",
        "kontakDarurat",
        "namaKontakDarurat",
        "hubunganKontakDarurat",
        "negara",
        "provinsi",
        "kota",
        "alamat",
        ...(eventId === "JOTR" ? ["performanceIndex", "stravaProfile"] : []),
      ];
      const missingUserFields = requiredUserFields.filter(
        (field) => !userData[field] || userData[field].trim() === ""
      );
      if (missingUserFields.length > 0) {
        throw new Error(
          `Data pengguna tidak lengkap: ${missingUserFields.join(
            ", "
          )} wajib diisi.`
        );
      }

      await simpanSuratPernyataanSebagaiPDF();

      const payload = {
        namaDepan: sanitizedFormData.namaDepan,
        namaBelakang: sanitizedFormData.namaBelakang,
        namaLengkap: sanitizedFormData.namaLengkap,
        email: sanitizedFormData.email,
        telepon: sanitizedFormData.telepon,
        nomorIdentitas: sanitizedFormData.nomorIdentitas,
        tanggalLahir: sanitizedFormData.tanggalLahir,
        gender: sanitizedFormData.gender,
        negara: sanitizedFormData.negara,
        provinsi: sanitizedFormData.provinsi,
        kota: sanitizedFormData.kota,
        alamat: sanitizedFormData.alamat,
        kontakDarurat: sanitizedFormData.kontakDarurat,
        namaKontakDarurat: sanitizedFormData.namaKontakDarurat,
        hubunganKontakDarurat: sanitizedFormData.hubunganKontakDarurat,
        bibName: eventId === "JOTR" ? sanitizedFormData.bibName : undefined,
        golonganDarah:
          eventId === "JOTR" ? sanitizedFormData.golonganDarah : undefined,
        sizeJersey:
          eventId === "JOTR" ? sanitizedFormData.sizeJersey : undefined,
        performanceIndex:
          eventId === "JOTR" ? sanitizedFormData.performanceIndex : undefined,
        stravaProfile:
          eventId === "JOTR" ? sanitizedFormData.stravaProfile : undefined,
        kategori: eventId === "JOTR" ? categoryName : undefined,
        seminar: eventId === "PelatihanPelatih" ? categoryName : undefined,
        distance: distance || 0,
        harga: Math.floor(finalPrice),
        eventId,
        voucherCode,
        uid: user.uid,
        collectionName,
        teamName: isGroupRegistration ? sanitizedFormData.teamName : undefined,
        participants: isGroupRegistration
          ? sanitizedFormData.participants.slice(1)
          : undefined,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/register`,
        payload
      );

      if (finalPrice === 0) {
        setSuccessMsg("System hacked 🤯 Registration 100% free!");
        showNotification("success", "System hacked 🤯 Registration 100% free!");
        setOrderId(response.data.orderId);
        const draftDocRef = doc(db, "registrations", `${user.uid}_${eventId}`);
        await deleteDoc(draftDocRef);
        setTimeout(
          () =>
            navigate(
              `/myregistration?order_id=${response.data.orderId}&transaction_status=settlement`
            ),
          2000
        );
        return;
      }

      const { snapToken, orderId } = response.data;
      setSnapToken(snapToken);
      setOrderId(orderId);

      window.snap.pay(snapToken, {
        onSuccess: async () => {
          setSuccessMsg("Pembayaran berhasil!");
          showNotification("success", "Pembayaran berhasil!");
          const draftDocRef = doc(
            db,
            "registrations",
            `${user.uid}_${eventId}`
          );
          await deleteDoc(draftDocRef);
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=settlement`
          );
        },
        onPending: async () => {
          setSuccessMsg("Pembayaran sedang diproses.");
          showNotification("warning", "Pembayaran sedang diproses.");
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=pending`
          );
        },
        onError: () => {
          setErrorMsg("Pembayaran gagal. Silakan coba lagi.");
          showNotification("error", "Pembayaran gagal. Silakan coba lagi.");
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=failed`
          );
        },
        onClose: () => {},
      });
    } catch (error) {
      let errorMessage = "Pendaftaran gagal. Silakan coba lagi.";
      let errorDetails = "";
      if (error.response?.data) {
        errorMessage = error.response.data.message || errorMessage;
        if (error.response.data.errors) {
          const errors = error.response.data.errors;
          if (errors.firstParticipant) {
            errorMessage =
              Object.values(errors.firstParticipant)[0] || errorMessage;
          } else if (errors.participant_1 || errors.participant_2) {
            errorMessage =
              Object.values(errors.participant_1 || errors.participant_2)[0] ||
              errorMessage;
          }
          errorDetails = JSON.stringify(errors, null, 2);
        }
      } else {
        errorMessage = error.message || errorMessage;
      }
      setErrorMsg(`${errorMessage}${errorDetails ? `: ${errorDetails}` : ""}`);
      showNotification(
        "error",
        `${errorMessage}${errorDetails ? `: ${errorDetails}` : ""}`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleBayar = async () => {
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    if (!isSnapReady || !window.snap) {
      setErrorMsg("Midtrans belum siap. Silakan coba lagi.");
      showNotification("error", "Midtrans belum siap. Silakan coba lagi.");
      setLoading(false);
      return;
    }

    if (!snapToken || !orderId) {
      setErrorMsg("Token pembayaran atau order ID tidak ditemukan.");
      showNotification(
        "error",
        "Token pembayaran atau order ID tidak ditemukan."
      );
      setLoading(false);
      return;
    }

    try {
      window.snap.pay(snapToken, {
        onSuccess: async () => {
          setSuccessMsg("Pembayaran berhasil!");
          showNotification("success", "Pembayaran berhasil!");
          const draftDocRef = doc(
            db,
            "registrations",
            `${user.uid}_${eventId}`
          );
          await deleteDoc(draftDocRef);
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=settlement`
          );
        },
        onPending: async () => {
          setSuccessMsg("Pembayaran sedang diproses.");
          showNotification("warning", "Pembayaran sedang diproses.");
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=pending`
          );
        },
        onError: () => {
          setErrorMsg("Pembayaran gagal. Silakan coba lagi.");
          showNotification("error", "Pembayaran gagal. Silakan coba lagi.");
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=failed`
          );
        },
        onClose: () => {},
      });
    } catch (err) {
      setErrorMsg("Gagal memproses pembayaran. Silakan coba lagi.");
      showNotification("error", "Gagal memproses pembayaran.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isSettled = transactionStatus === "settlement";
  const isPending = transactionStatus === "pending";
  const isFormDisabled = isSettled || isPending;

  return (
    <div className="min-h-screen bg-white shadow-xl px-4 sm:px-6 lg:px-8 z-0">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-4 py-20 overflow-visible">
        <div className="w-full md:w-3/4 max-w-4xl bg-white p-4 rounded-xl border border-slate-200 backdrop-blur-md">
          <h2 className="text-2xl font-semibold text-left mb-4">
            Form Pendaftaran JOTR
          </h2>
          <form id="form-pendaftaran" onSubmit={handleSubmit}>
            <InputFieldRace
              formData={formData}
              handleChange={handleChange}
              isFormDisabled={isFormDisabled}
              labelColor={labelColor}
              eventId={eventId}
              categoryName={categoryName}
              updateUserData={updateUserData}
            />
          </form>
        </div>

        <div className="w-full md:w-1/4 max-w-sm bg-white p-4 rounded-xl border border-slate-200 backdrop-blur-md flex flex-col gap-4">
          <h2 className="text-2xl font-semibold text-left">
            Informasi Pesanan
          </h2>
          <div className="text-lg text-left">
            <p>
              Kategori: <strong>{categoryName || title}</strong>
            </p>
            {isGroupRegistration && (
              <>
                <p>
                  Nama Tim:{" "}
                  <strong>{formData.teamName || "Belum diisi"}</strong>
                </p>
                <p>
                  Jumlah Peserta:{" "}
                  <strong>{formData.participants.length} orang</strong>
                </p>
              </>
            )}
            <p>
              Harga: <strong>Rp {finalPrice.toLocaleString()}</strong>
            </p>
            {discount > 0 && (
              <p>
                Diskon: <strong>{discount}%</strong>
              </p>
            )}
          </div>

          {(errorMsg || successMsg) && (
            <p
              className={`text-left font-medium ${
                errorMsg ? "text-rose-600" : "text-slate-800"
              }`}
            >
              {errorMsg || successMsg}
            </p>
          )}

          {registrationStatus === "registered" && isSettled && (
            <p className="text-left text-slate-800 font-medium">
              Anda sudah terdaftar pada event ini.
            </p>
          )}

          {registrationStatus === "registered" && isPending && (
            <p className="text-left text-slate-800 font-medium">
              Menunggu pembayaran.
            </p>
          )}

          <hr className="border-t border-gray-300" />

          <VoucherInput
            onApplyVoucher={handleApplyVoucher}
            disabled={isFormDisabled}
            eventId={eventId}
          />
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="syarat"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              className="w-5 h-5 focus:ring-2 focus:ring-lime-600"
              disabled={isFormDisabled}
            />
            <label htmlFor="syarat" className="text-sm">
              Saya telah membaca dan menyetujui{" "}
              <a
                href="/SuratPernyataan"
                target="_blank"
                className="text-lime-600 underline"
              >
                Surat Pernyataan
              </a>
            </label>
          </div>

          <div>
            {isSettled ? (
              <Button
                type="button"
                variant="none"
                className="w-full h-auto py-3 bg-slate-400 font-semibold rounded-xl"
                disabled
              >
                Sudah Terdaftar
              </Button>
            ) : isPending ? (
              <Button
                type="button"
                variant="none"
                onClick={handleBayar}
                className={`w-full h-auto py-3 bg-lime-600 hover:bg-lime-700 text-white font-semibold rounded-xl`}
                disabled={loading}
              >
                {loading ? "Loading..." : "Selesaikan Pembayaran"}
              </Button>
            ) : (
              <Button
                type="submit"
                form="form-pendaftaran"
                variant="none"
                className={`w-full h-auto py-3 bg-lime-600 hover:bg-lime-700 text-white font-semibold rounded-xl`}
                disabled={loading || !isChecked}
              >
                {loading
                  ? "Loading..."
                  : finalPrice === 0
                  ? "Complete the Hack"
                  : "Daftar dan Bayar"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
